import React,{useState,useEffect} from 'react'
import Label from './Label'
import { Button,Dialog, Alert,Icon,Collapse} from "@blueprintjs/core";
import {setDoc,doc, collection,query,where,limit, onSnapshot} from 'firebase/firestore'
import { useAuthState } from 'react-firebase-hooks/auth';
import {getAuth} from 'firebase/auth'
import db from '../firebase/config'
const uniqueId = require('react-unique-nums')
const auth = getAuth()

function Sider(props) {
    const [visible,setVisible] =useState(false)
    const [selected,setSelected] =useState('#30404D')
    const [label,setLabel] = useState("")
    const [user] = useAuthState(auth)
    const [show,setShow] = useState(false)
    const [allLabels,setAllLabels] = useState([])
    const [initial,setInitial] = useState(30)
    const [disabled,setDisabled] = useState(true)
    const [open,setOpen] = useState(false)
    const {childData} = props
    const setDataNull = props.setDataNull

    const createLabel  = async() =>{
          const label_id = uniqueId()
          const docRef = doc(collection(db, "labels"));
          await setDoc(docRef,{
                id:label_id,
                name:label,
                owner:user.email,
                owner_name:user.displayName,
                owner_photo:user.photoURL,
                color:selected,
          });
          await setShow(true)
          await setVisible(false)
    }
   
    useEffect(() => {
        const getLabelFn = async() => {
            let queryRef = query(
                collection(db,"labels"),
                where("owner",'==',user.email),
                limit(initial)
           );

             await onSnapshot(queryRef,(snapshot) =>{
               let resArry = []
               if(snapshot.empty) {console.log("empty snapshot")}
               snapshot.forEach(doc =>{
                resArry.push({
                    id:doc.data().id,
                    name:doc.data().name,
                    owner:doc.data().owner,
                    owner_name:doc.data().owner_name,
                    owner_photo:doc.data().owner_photo,
                    color:doc.data().color,
                    docId:doc.id
                   });
               })
               setAllLabels(resArry)
           })
        }
        getLabelFn()
        return ()=> getLabelFn()
    },[])

     useEffect(()=>{
         if(label === "") {setDisabled(true)} else setDisabled(false)
     },[label])
    return (
        <div>
            <div id="just-bar">
             <h2 id="h3">Labels</h2>
                <Button id="button" icon="add" onClick={()=>setVisible(prev=>!prev)}>Add new label</Button>
            </div>
             {allLabels.length <= 0 ? 
                    <div>
                        <Icon icon="label"  size={80} color="#0F9960" style={{marginLeft:'40%',marginTop:40}}/>
                        <h3  style={{textAlign: 'center',color:'#ecf1f5'}}>No, any label yet</h3>
                            <p style={{textAlign: 'center',color:'#ecf1f5'}}>Click " + add new label" to create label"</p>
                    </div>:
                     <div id="allLabels-div">
                         {allLabels.map(item=>(
                             <div key={item.id} onClick={()=>childData(item)}>
                                 <Label info={item} key={item.id} setDataNull={setDataNull}  />
                             </div>
                         ))}
                         </div>}

                         <div id="small-devices-label-container">
                            <div id="just-bar" onClick={()=>setOpen(prev=>!prev)}>
                                <h3 id="hide-in-small-h3" style={{color: '#ecf1f5',padding:10}}> Show labels</h3>
                                 <Icon id="hide-in-small-icon" icon={open ? "caret-up": "caret-down"} color={"#ecf1f5"}  style={{padding:10,marginTop:20}}/>
                            </div>
                            <Collapse isOpen={open}>
                            {allLabels.length <= 0 ? 
                                <div>
                                    <Icon icon="label"  size={80} color="#0F9960" style={{marginLeft:'40%',marginTop:40}}/>
                                    <h3  style={{textAlign: 'center',color:'#ecf1f5'}}>No, any label yet</h3>
                                        <p style={{textAlign: 'center',color:'#ecf1f5'}}>Click " + add new label" to create label"</p>
                                </div>:
                    
                                <div>
                                    {allLabels.map(item=>(
                                        <div key={item.id} onClick={()=>childData(item)}>
                                             <Label info={item} key={item.id} setDataNull={setDataNull}  />
                                        </div>
                                     ))}
                                    </div>}

                            </Collapse>
                         </div>




                <Dialog isOpen={visible} style={{backgroundColor:selected}}>
                    <h3 style={{paddingLeft:20,color:'#ecf1f5',fontSize:24}}>Add a new label</h3>
                      <p style={{paddingLeft:20,marginTop:-10,color:'#ecf1f5'}}>Label is just a container for holding items</p>
                         <input type="text" placeholder="Label title" id="input" 
                         value={label}
                         onChange={e=>{setLabel(e.target.value)}} />
                         <div id="just-bar" style={{marginLeft:'2%'}}>

                            <div id="color-container" style={{backgroundColor:"#5C255C"}} onClick={()=>setSelected("#5C255C")}/>
                            <div id="color-container" style={{backgroundColor:"#1D7324"}} onClick={()=>setSelected("#1D7324")}/>
                            <div id="color-container" style={{backgroundColor:"#154360"}} onClick={()=>setSelected("#154360")}/>
                            <div id="color-container" style={{backgroundColor:"#F1C40F"}} onClick={()=>setSelected("#F1C40F")}/>
                            <div id="color-container" style={{backgroundColor:"#138D75"}} onClick={()=>setSelected("#138D75")}/>
                            <div id="color-container" style={{backgroundColor:"#273746"}} onClick={()=>setSelected("#273746")}/>
                            <div id="color-container" style={{backgroundColor:"#3498DB"}} onClick={()=>setSelected("#3498DB")}/>

                        </div>

                     <div style={{flexDirection:'row',alignSelf:'flex-end',marginLeft:-10}}>
                     <button id="ok" style={{opacity:0.6}} onClick={()=>setVisible(prev=>!prev)}>Cancel</button>
                        <button id="ok" onClick={()=>createLabel()} disabled={disabled}>Create</button>
                     </div>
                </Dialog>

                <Alert  isOpen={show} canOutsideClickCancel={true}	onClose={()=>setShow(prev=>!prev)}>Label successfully created</Alert>
        </div>
    )
}

export default Sider
